module.exports = window.slice.ReactDOM;